import React, { useRef } from "react";
import { gql } from "@apollo/client";

import "./UploadFileFooter.scss";
import { NavLink } from "react-router-dom";
import { notify } from "../../Notify/Notify";
import { uploadClient } from "../../../index";

const UploadFileFooter = (props) => {
  let documentList = [];

  let addBtnRef = useRef();
  let draftBtnRef = useRef();

  async function callUpload(status) {
    props.loadingStatus();
    let fileUploadedCount = 0;

    if (addBtnRef.current) {
      addBtnRef.current.setAttribute("disabled", "disabled");
      draftBtnRef.current.setAttribute("disabled", "disabled");
    }

    for (let index = 0; index < props.files.length; index++) {
      const fileObj = props.files[index];
      const fileName =
        fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[0].fieldValue;

      if (props.selectedFileObj.id === fileObj.id) {
        fileObj.fileAbstract = props.selectedFileObj.fileAbstract;
      }

      const UPLOAD_FILE = gql`
        mutation UploadSingleDocument(
          $file: Upload!
          $title: String!
          $subFolderId: UUID!
          $documentTemplateId: UUID!
          $tagId: UUID
          $abstract: String!
          $status: Int!
        ) {
          uploadSingleDocument(
            file: $file
            folderId: $subFolderId
            title: $title
            documentTypeId: $documentTemplateId
            tagId: $tagId
            abstract: $abstract
            status: $status
          ) {
            document {
              id
            }
            success
          }
        }
      `;
      const documentType =
        fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[1];
      let documentTypeId = documentType.options.filter(
        (x) => x.optionValue === documentType.fieldValue
      );

      const selectedTag =
        fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[3];

      let tagId = [];
      if (selectedTag) {
        tagId = selectedTag.options.filter(
          (x) => x.optionValue === selectedTag.fieldValue
        );
        // Clear options so that backend don't store stale copy of tags
        selectedTag.options = [];
        fileObj.fileAbstract[
          fileObj.fileAbstract.length - 1
        ].tabSections[0].sectionFields.splice(3, 0);
      }

      const variables = {
        file: fileObj.file,
        title: fileName,
        subFolderId: props.match.params.subFolderId,
        abstract: JSON.stringify(fileObj.fileAbstract),
        documentTemplateId: documentTypeId[0].optionId,
        tagId: tagId.length > 0 ? tagId[0].optionId : undefined,
        status: status, // 1 Active, 2 Draft
      };

      // Handle move submission
      // Note:- This is not a good way to do it. It is just a work around
      if (fileObj?.isForMovedFile) {
        try {
          const variables = {
            file: fileObj.file,
            abstract: JSON.stringify(fileObj.fileAbstract),
            documentId: fileObj.id,
            title: fileName,
            documentTypeId: documentTypeId[0].optionId,
            tagId: tagId.length > 0 ? tagId[0].optionId : undefined,
            statusId: status,
            isNewField: false,
            isDocumentEdited: true,
          };

          const result = await uploadClient.mutate({
            mutation: gql`
              mutation editDocument(
                $file: Upload!
                $abstract: String
                $documentId: UUID!
                $title: String
                $documentTypeId: UUID
                $tagId: UUID
                $statusId: Int
                $isNewField: Boolean!
                $isDocumentEdited: Boolean!
              ) {
                editDocument(
                  file: $file
                  abstract: $abstract
                  documentId: $documentId
                  title: $title
                  documentTypeId: $documentTypeId
                  tagId: $tagId
                  statusId: $statusId
                  isNewField: $isNewField
                  isDocumentEdited: $isDocumentEdited
                ) {
                  success
                }
              }
            `,
            variables: variables,
          });
          if (result?.data?.editDocument?.success) {
            notify("Success", fileName + " uploaded successfully!", "success");
            props.disableLoading();
            props.reminderModal([variables.documentId]);

            // props.history.push(
            //   "/files/".concat(
            //     props.match.params.folderId,
            //     "/",
            //     props.match.params.subFolderId
            //   )
            // );
          } else {
            props.disableLoading();
            notify(
              "Error",
              "Oops!! some error occurred please try again.",
              "error"
            );
          }
          return;
        } catch (error) {
          console.error("Error occurred:", error);
          // Handle error here
          props.disableLoading();
          notify(
            "Error",
            "Oops!! some error occurred please try again.",
            "error"
          );
          addBtnRef.current.removeAttribute("disabled");
          draftBtnRef.current.removeAttribute("disabled");
        }
        return;
      }

      uploadClient
        .mutate({
          mutation: UPLOAD_FILE,
          variables: variables,
        })
        // eslint-disable-next-line no-loop-func
        .then((result) => {
          if (result.data.uploadSingleDocument.success) {
            fileUploadedCount = fileUploadedCount + 1;
            documentList.push(result.data.uploadSingleDocument.document.id);
            if (documentList.length === props.files.length) {
              props.reminderModal(documentList);
            }
            if (fileUploadedCount === props.files.length) {
              if (props.files.length === 1) {
                notify(
                  "Success",
                  fileName + " uploaded successfully!",
                  "success"
                );
              } else {
                notify(
                  "Success",
                  "All files have been successfully uploaded",
                  "success"
                );
              }
            }
          } else {
            props.disableLoading();
            notify(
              "Error",
              "Oops!! some error occurred please try again.",
              "error"
            );
            addBtnRef.current.setAttribute("disabled", false);
            draftBtnRef.current.setAttribute("disabled", false);
          }
        })
        .catch((e) => {
          props.disableLoading();
          notify(
            "Error",
            "Oops!! some error occurred please try again.",
            "error"
          );
        });
    }
  }

  const hasValidValuesDraft = () => {
    if (!(props.files.length > 0)) {
      return false;
    }
    for (let index = 0; index < props.files.length; index++) {
      const fileObj = props.files[index];

      if (props.selectedFileObj && props.selectedFileObj.id === fileObj.id) {
        fileObj.fileAbstract = props.selectedFileObj.fileAbstract;
      }

      if (
        !fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[1].fieldValue ||
        fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[1].fieldValue === "Select one"
      ) {
        return false;
      }
    }
    return true;
  };

  const hasValidValues = () => {
    if (!(props.files.length > 0)) {
      return false;
    }

    for (let index = 0; index < props.files.length; index++) {
      const fileObj = props.files[index];

      if (props.selectedFileObj && props.selectedFileObj.id === fileObj.id) {
        fileObj.fileAbstract = props.selectedFileObj.fileAbstract;
      }

      if (
        !fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[1].fieldValue ||
        fileObj.fileAbstract[fileObj.fileAbstract.length - 1].tabSections[0]
          .sectionFields[1].fieldValue === "Select one"
      ) {
        return false;
      }

      for (let fIndex = 0; fIndex < fileObj.fileAbstract.length; fIndex++) {
        const fObj = fileObj.fileAbstract[fIndex];

        for (let tIndex = 0; tIndex < fObj.tabSections.length; tIndex++) {
          const tabObj = fObj.tabSections[tIndex];

          for (let sIndex = 0; sIndex < tabObj.sectionFields.length; sIndex++) {
            const sectionObj = tabObj.sectionFields[sIndex];

            if (sectionObj && sectionObj.fieldRequired) {
              if (
                !(
                  sectionObj.hasOwnProperty("fieldValue") &&
                  sectionObj.fieldValue.length > 0
                )
              ) {
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  };

  return (
    <div className="upload-file-footer d-flex px-8">
      <span className="text">{""}</span>
      <div className="d-flex">
        <NavLink
          to={"/files/".concat(
            props.match.params.folderId,
            "/",
            props.match.params.subFolderId
          )}
        >
          <button className="btn-tertiary mx-2">Cancel</button>
        </NavLink>
        <button
          ref={draftBtnRef}
          className="btn-secondary mx-2"
          onClick={() => {
            if (hasValidValuesDraft()) {
              callUpload(2);
            } else {
              notify(
                "Error",
                "Please fill in all required fields before proceeding.",
                "error"
              );
            }
          }}
        >
          Save as draft
        </button>
        <button
          ref={addBtnRef}
          className="btn-primary mx-2"
          onClick={() => {
            if (hasValidValues()) {
              callUpload(1);
              return;
            } else {
              notify(
                "Error",
                "Please fill in all required fields before proceeding.",
                "error"
              );
            }
          }}
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default UploadFileFooter;
